import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';

export default class ExpandAndCollapse extends Module {
	private el! : HTMLSdxExpandAndCollapseElement;
	private isOpen = false;
	public on(callback : Hook) {
		this.el = this.$ctx[0] as HTMLSdxExpandAndCollapseElement;
		this.isOpen = this.el.open;
		callback();
	}
	public after() {
		this.el.addEventListener('click', this.track.bind(this));
	}
	private track() {
		if (this.el.open === this.isOpen) {
			return;
		}
		this.isOpen = this.el.open;
		SCS.portal.datalayer.trackEvent(
			this.isOpen ? 'open' : 'close',
			this.el.dataset.trackingLabel!,
			this.el.dataset.trackingLocation!,
			this.el.dataset.trackingCategory!,
		);
	}
}




// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/expandandcollapse/Tc.Module.ExpandAndCollapse.ts